import React from 'react';
import { Form, Checkbox } from 'antd';
import { fieldNames } from './constants';

const { Item: FormItem } = Form;

const AvailableForClientField = ({ form, initialValue }) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem colon={false}>
      {getFieldDecorator(fieldNames.availableToClient, {
        initialValue: initialValue ?? true,
        valuePropName: 'checked',
      })(<Checkbox>Показывать собственнику</Checkbox>)}
    </FormItem>
  );
};

export default AvailableForClientField;
